export default __webpack_public_path__ + "static/media/circle-check-green.1004b8bf.svg";